import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  scrollBox: {
    height: `calc(100vh - 64px)`,
    display: 'flex',
    flexDirection: 'column',
  },
  tableContainer: {
    height: '320px',
    flex: '1 1 auto',
    margin: `${theme.spacing(3)} 0 0`,
    padding: `0 0 ${theme.spacing(3)}`,
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.grey[300]} `,
    width: '100%',
    fontSize: '20px',
  },
  inputWrapper: {
    display: 'flex',
    columnGap: theme.spacing(2),
    alignItems: 'center'
  },
}));
export default useStyles;